import type { TypeAdditionalHours } from 'types/actionPlan';
import { useTranslation } from 'react-i18next';
import Text from '@ingka/text';
import classes from '../ActionTable.module.scss';

const AdditionalHoursAction = ({ action }:{ action: TypeAdditionalHours }) => {
    const { t } = useTranslation();
    const delta = Number(action.from) - Number(action.to);

    return (
        <div className={classes['details-changes']}>
            <div className={classes['details-changes-container']}>
                <Text
                    tagName="span"
                    textStyle="Heading.S"
                    data-testid="action-plan-additional-hours-header"
                >
                    {t('actionPlan.table.additional_hours')}
                </Text>
                <Text
                    data-testid="action-plan-additional-hours-change"
                >
                    {delta < 0 ? `+${delta} ${t('globals.labels.hours_abbreviated')}` : `-${delta} ${t('globals.labels.hours_abbreviated')}`}
                </Text>
            </div>
        </div>
    );
};

export default AdditionalHoursAction;
